import { GuestTypeRequests } from '@/services/guest-type.requests'
const guestTypesService = new GuestTypeRequests()

const state = {
  list: []
}

const getters = {}

const actions = {
  list ({ state }) {
    return new Promise((resolve, reject) => {
      guestTypesService.list().then(async (guestTypes) => {
        state.list = guestTypes
        resolve(guestTypes)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
